module.exports = __webpack_public_path__ + "static/media/background.26129b0a.png";